module.exports = __webpack_public_path__ + "img/wxcode.8f4488e7.jpg";